import { useState, useEffect } from 'react';
import "./GenerativePrinciple.css";
import '../Generativecommon.css';
import img1 from "../generativeassets/ailogo1.png";
import img2 from "../generativeassets/ailogo2.png";
import img3 from "../generativeassets/ailogo3.png";
import img4 from "../generativeassets/ailogo4.png";
import img5 from "../generativeassets/ailogo5.png";

const cards = [
  {
    img: img1,
    head: "Secure",
    subhead:
      "We build secure GenAI solutions using encryption, access controls, and monitoring to protect sensitive data and ensure enterprise-grade integrity.",
  },
  {
    img: img2,
    head: "Ethical",
    subhead:
      "We prioritize fairness, transparency, and privacy at every stage. Our models are responsibly designed and trained to mitigate bias, ensuring inclusive, trustworthy AI aligned with global compliance standards.",
  },
  {
    img: img3,
    head: "Intuitive",
    subhead:
      "We design AI systems that are easy to use and easy to trust. Clear, thoughtful interfaces enable users to interact effortlessly and realize value without added complexity.",
  },
  {
    img: img4,
    head: "Reliable",
    subhead:
      "We apply rigorous quality assurance across development and training, including continuous testing, validation, and monitoring to ensure accuracy, relevance, and consistent performance.",
  },
  {
    img: img5,
    head: "Useful",
    subhead:
      "Our AI solutions solve real business challenges. From streamlining workflows to improving decisions, every model is purpose-driven and delivers measurable impact.",
  },
];

export default function GenerativePrinciple() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isCarousel, setIsCarousel] = useState(false);
  const [cardsPerView, setCardsPerView] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      
      if (width < 576) {
        setIsCarousel(true);
        setCardsPerView(1);
      } else if (width < 992) {
        setIsCarousel(true);
        setCardsPerView(2);
      } else {
        setIsCarousel(false);
        setCardsPerView(5);
      }
      setCurrentIndex(0);
    };

    handleResize();
    
    let timeoutId;
    const debouncedResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(handleResize, 100);
    };

    window.addEventListener('resize', debouncedResize);
    return () => {
      window.removeEventListener('resize', debouncedResize);
      clearTimeout(timeoutId);
    };
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => {
      const maxIndex = cards.length - cardsPerView;
      return prevIndex >= maxIndex ? 0 : prevIndex + 1;
    });
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => {
      const maxIndex = cards.length - cardsPerView;
      return prevIndex <= 0 ? maxIndex : prevIndex - 1;
    });
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const totalDots = cards.length - cardsPerView + 1;
  const cardWidth = 100 / cardsPerView;

  return (
    <div id="generative-principle" className="generativemainclass">
      <h2 className="heading">Our Generative AI Principles</h2>
      <p className="subheading">
        Building Responsible and Ethical AI Solutions
      </p>

      {isCarousel ? (
        <div className="carousell-container">
          <button className="carousel-btn prev" onClick={prevSlide}>
            &#8249;
          </button>
          
          <div className="carousel-wrapper">
            <div 
              className="carousel-track"
              style={{
                transform: `translateX(-${currentIndex * cardWidth}%)`,
              }}
            >
              {cards.map((card, index) => (
                <div 
                  className="carousel-card" 
                  key={index}
                  style={{ width: `${cardWidth}%` }}
                >
                  <img src={card.img} alt={card.head} />
                  <h3>{card.head}</h3>
                  <span>{card.subhead}</span>
                </div>
              ))}
            </div>
          </div>

          <button className="carousel-btn next" onClick={nextSlide}>
            &#8250;
          </button>

          <div className="carousel-dots">
            {[...Array(totalDots)].map((_, index) => (
              <button
                key={index}
                className={`dot ${currentIndex === index ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      ) : (
        <div className="cards">
          {cards.map((card, index) => (
            <div className="card" key={index}>
              <img src={card.img} alt={card.head} />
              <h3>{card.head}</h3>
              <span>{card.subhead}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}